import { Checkbox, RadioGroup, RadioGroupItem } from '@/components/Form';

import type { DataTableRowSelectionType } from './types';

const rowRadioValue = 'data-table-row';

type DataTableSelectionControlProps = {
  type: DataTableRowSelectionType;
  checked: boolean;
  ariaLabel: string;
  disabled?: boolean;
  indeterminate?: boolean;
  onChange: (checked: boolean) => void;
};

const DataTableSelectionControl = ({
  type,
  checked,
  ariaLabel,
  disabled = false,
  indeterminate = false,
  onChange,
}: DataTableSelectionControlProps) => {
  if (type === 'radio') {
    return (
      <RadioGroup
        value={checked ? rowRadioValue : undefined}
        onValueChange={(value) => {
          if (value === rowRadioValue) {
            onChange(true);
          }
        }}
        disabled={disabled}
      >
        <RadioGroupItem
          value={rowRadioValue}
          aria-label={ariaLabel}
          onClick={(event) => event.stopPropagation()}
        />
      </RadioGroup>
    );
  }

  return (
    <Checkbox
      checked={checked}
      indeterminate={indeterminate}
      disabled={disabled}
      aria-label={ariaLabel}
      onClick={(event) => event.stopPropagation()}
      onCheckedChange={onChange}
    />
  );
};

export default DataTableSelectionControl;
